import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { InstanceService } from '../services/instance.service';
import { SessionService } from '../services/session.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private cookieService: CookieService,
    private sessionService: SessionService,
    private instanceService: InstanceService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    if (!this.cookieService.check('app-center-sessionId')) {
      return of(this.redirectToLogin());
    }

    return this.sessionService.session$.pipe(
      switchMap((session) => {
        if (!session.isValid) {
          this.cookieService.deleteAll();
          return of(this.redirectToLogin());
        }
        if (session.hasSuperOps || session.hasSuperAdmin) {
          return of(true);
        }
        // Check if app is enabled
        if (this.isLocalhost()) {
          return of(true);
        }
        return this.sessionService.apps$;
      }),
      map((apps) => {
        if (Array.isArray(apps)) {
          const item = apps.find((item) => item.url.includes(window.location.host));
          if (item !== undefined) {
            return true;
          } else {
            return this.redirectToLogin();
          }
        }
        return apps;
      })
    );
  }

  // Check if the app is running on localhost
  // used a function to allow to mock it in tests
  isLocalhost(): boolean {
    return window.location.href.includes('localhost');
  }

  // Redirect to app center login
  // Not testable because it uses window.location
  redirectToLogin(): boolean {
    window.location.href = this.instanceService.appCenterUrl;
    return false;
  }
}
